import * as React from 'react';

export const SolvdCheckCircle = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="33" height="33" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M10.4004 0.5C15.8678 0.500211 20.2998 4.9329 20.2998 10.4004C20.2996 15.8677 15.8677 20.2996 10.4004 20.2998C4.9329 20.2998 0.500211 15.8678 0.5 10.4004C0.5 4.93277 4.93277 0.5 10.4004 0.5ZM15.5732 6.52734C14.8703 5.8244 13.7303 5.8244 13.0273 6.52734L9.09961 10.4541L7.77246 9.12695C7.06959 8.4244 5.93041 8.4244 5.22754 9.12695C4.5246 9.8299 4.5246 10.9699 5.22754 11.6729L7.82715 14.2725C8.53009 14.9754 9.6701 14.9754 10.373 14.2725L15.5732 9.07324C16.2761 8.3704 16.2759 7.23031 15.5732 6.52734Z"
			fill="#12856A"
			stroke="#12856A"
		/>
	</svg>
);
